import { ModalDesktop } from '@adc/parallax-component-library';
import i18n from './i18n';

function showUnderDevelopmentWarning() {
  ModalDesktop.show({
    title: i18n.t('Common.underDevelopment.title'),
    details: i18n.t('Common.underDevelopment.message'),
    buttons: [
      {
        label: i18n.t('Common.ok'),
        onPress: () => ModalDesktop.hide(),
      },
    ],
  });
}

export default showUnderDevelopmentWarning;
